import classNames from "classnames";
import React, { forwardRef, Ref, useImperativeHandle, useRef } from "react";
import AppInput, { AppInputProps, AppInputRef } from "../app-input/AppInput";

import Styles from "./FlatInput.module.scss";

export interface FlatInputRef extends AppInputRef {}

interface FlatInputProps<T> extends AppInputProps<T> {}

const FlatInput = forwardRef(
    <T extends string | number | readonly string[] | undefined>(
        {
            id,
            className,
            containerClassName,
            labelClassName,
            inputWrapperClassName,
            inputClassName,
            prefixClassName,
            suffixClassName,
            errorClass,
            ...props
        }: FlatInputProps<T>,
        forwardedRef: Ref<FlatInputRef>
    ) => {
        const appInputRef = useRef<AppInputRef>(null);

        useImperativeHandle(forwardedRef, () => ({ focus: appInputRef.current?.focus || (() => {}) }));

        return (
            <AppInput
                id={id}
                className={classNames(className)}
                containerClassName={classNames(Styles.inputContainer, containerClassName)}
                inputWrapperClassName={classNames(Styles.inputWrapper, inputWrapperClassName)}
                labelClassName={classNames(Styles.label, labelClassName)}
                inputClassName={classNames(Styles.input, inputClassName)}
                prefixClassName={classNames(Styles.prefix, prefixClassName)}
                suffixClassName={classNames(Styles.suffix, suffixClassName)}
                activeClassName={classNames(Styles.active)}
                dirtyClassName={classNames(Styles.dirty)}
                errorClass={errorClass}
                {...props}
            />
        );
    }
);

export default FlatInput;
